import { render } from "./KpiGrid.vue?vue&type=template&id=68967ccc&scoped=true"
import script from "./KpiGrid.vue?vue&type=script&lang=js"
export * from "./KpiGrid.vue?vue&type=script&lang=js"

import "./KpiGrid.vue?vue&type=style&index=0&id=68967ccc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68967ccc"]])

export default __exports__